import Choices from "choices.js";
import baron from "baron";

export default function Select(selectBlock) {
  const selectBaseClass = selectBlock.getAttribute("data-base-class");
  const selectElement = selectBlock.querySelector("select");

  new Choices(selectElement, {
    searchEnabled: false,
    shouldSort: false,
    classNames: {
      containerOuter: `${selectBaseClass}__container`,
      containerInner: `${selectBaseClass}__inner`,
      list: `${selectBaseClass}__list`,
      listSingle: `${selectBaseClass}__label`,
      listDropdown: `${selectBaseClass}__dropdown`,
      item: `${selectBaseClass}__item`,
      itemSelectable: `${selectBaseClass}__item_selectable`,
      itemChoice: `${selectBaseClass}__dropdown-item`,
      selectedState: `${selectBaseClass}__dropdown-item_selected`
    },
    callbackOnCreateTemplates(template) {
      const { classNames } = this.config;
      // const { itemSelectText } = this.config;

      return {
        dropdown: () => {
          return template(`
                        <div class="${classNames.listDropdown} js-select-scroller" aria-expanded="false"></div>
                    `);
        },
        choice: (data, itemSelectText) => {
          const selectedClass = data.selected ? classNames.selectedState : "";
          // const ariaSelected = data.active ? "aria-selected=\"true\"" : "";
          return template(`
                        <div
                            class="${classNames.item} ${
            classNames.itemChoice
          } ${
            data.highlighted
              ? classNames.highlightedState
              : classNames.itemSelectable
          } ${selectedClass}"
                            id="${data.elementId}"
                            data-select-text="${itemSelectText}"
                            data-choice
                            data-id="${data.id}"
                            data-value="${data.value}"
                            ${data.active ? 'aria-selected="true"' : ""}
                            ${data.disabled ? 'aria-disabled="true"' : ""}
                        >
                            ${data.label}
                        </div>
                    `);
        }
      };
    }
  });

  const selectDropdownBody = document.createElement("div");
  selectDropdownBody.className = `${selectBaseClass}__dropdown-body`;

  const baronScrollerContainer = selectBlock.querySelector(
    ".js-select-scroller"
  );
  const baronScroller = baronScrollerContainer.querySelector(".select__list");

  const selectScrollTrack = document.createElement("div");
  selectScrollTrack.className = `${selectBaseClass}__scrolltrack`;

  const selectScrollBar = document.createElement("div");
  selectScrollBar.className = `${selectBaseClass}__scrollbar`;

  selectScrollTrack.appendChild(selectScrollBar);
  baronScrollerContainer.appendChild(selectDropdownBody);
  selectDropdownBody.appendChild(baronScroller);
  baronScrollerContainer.appendChild(selectScrollTrack);

  const customScroller = baron({
    cssGuru: true,
    root: baronScrollerContainer,
    scroller: baronScroller,
    barOnCls: `${selectBaseClass}__dropdown_scrolling`,
    bar: selectScrollBar,
    direction: "v"
  });

  customScroller.controls({
    track: selectScrollTrack
  });

  baronScrollerContainer.style.display = "block";
  customScroller.update();
  baronScrollerContainer.style.display = "";

  // selectElement.addEventListener("change", function() {});
}
